var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "modal",
        {
          attrs: {
            show: !!_vm.currentModal,
            type: "dark",
            "prev-btn": _vm.showPrevButton,
            "close-btn": _vm.showCloseButton,
            "custom-btn": _vm.useCustomButton,
            "preview-btn": [_vm.modalTypes.update].includes(_vm.currentModal),
            "close-btn-size": _vm.closeBtnSize,
            closeable: true,
          },
          on: { prev: _vm.prevHanlder, closed: _vm.closeHandler },
          scopedSlots: _vm._u([
            {
              key: "customBtn",
              fn: function () {
                return [
                  _vm.currentModal === _vm.modalTypes.login
                    ? _c("span", [
                        _c(
                          "a",
                          {
                            staticClass: "register",
                            on: { click: _vm.showVisitorWelcomePopup },
                          },
                          [
                            _vm._v(
                              "\n          " +
                                _vm._s(_vm.$t("general.register")) +
                                "\n        "
                            ),
                          ]
                        ),
                      ])
                    : _vm._e(),
                ]
              },
              proxy: true,
            },
          ]),
        },
        [
          _vm._v(" "),
          [_vm.modalTypes.signup, _vm.modalTypes.update].includes(
            _vm.currentModal
          )
            ? _c("signup", {
                attrs: {
                  type: _vm.currentModal,
                  "form-data":
                    _vm.currentModal === _vm.modalTypes.signup
                      ? _vm.ticketInfo
                      : _vm.userFormData,
                },
                on: {
                  "to-login": function ($event) {
                    return _vm.setCurrentModal(_vm.modalTypes.login)
                  },
                  "to-change-password": function ($event) {
                    return _vm.setCurrentModal(_vm.modalTypes.password)
                  },
                  update: function ($event) {
                    return _vm.setCurrentModal("")
                  },
                  signup: function ($event) {
                    _vm.setCurrentModal("")
                    _vm.record($event)
                    _vm.enter($event)
                  },
                },
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.currentModal === _vm.modalTypes.password
            ? _c("password", {
                attrs: { username: _vm.authUser.email },
                on: {
                  "to-update": function ($event) {
                    return _vm.setCurrentModal(_vm.modalTypes.update)
                  },
                },
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.currentModal === _vm.modalTypes.login
            ? _c("login", {
                on: {
                  login: function ($event) {
                    return _vm.setCurrentModal("")
                  },
                },
              })
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }